// extracted by mini-css-extract-plugin
export default {"container":"l8rC1sBOXrFLeV79YKaJ","logo":"J74GQFOW68fraVac7GDv"};